import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { UiStore } from 'stores';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

// util
import { pageNames } from '../data/page-names';
import analyticsUtil from '../util/AnalyticsUtil';

export class SignInController implements Controller {
  public pageId = pageNames.signIn;
  public path = '/:localeName/signin';
  public routeName = 'signin';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "signin-page" */ '../views/signin-page'));
  public exact = true;

  public fetch(options: FetchOptions): Promise<Result> {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const context = request.context;

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve(Result.ok());
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Expedia Affiliate Program' }) as Promise<PageData>;
  }
}
